import SimpleTableItem from '@/models/general/simpleTableItem.js'

/**
 * @property {string} dateMeta - date in YYYY-MM-DD format
 * @property {string} date - date in friendly format
 * @property {string} startTime - start time of the shift
 * @property {string} endTime - end time of the shift
 * @property {Integer} candidateId - candidate Id
 * @property {string} name - candidate name (default is 'Unfilled')
 */
export default class ExtendBookingSummaryItem extends SimpleTableItem {
  constructor(
    dateMeta,
    date,
    startTime,
    endTime,
    candidateId = null,
    name = 'Unfilled',
    removed = false
  ) {
    super(removed)
    this.dateMeta = dateMeta
    this.date = date
    this.startTime = startTime
    this.endTime = endTime
    this.candidateId = candidateId
    this.name = name
  }
}
